export default __webpack_public_path__ + "static/usa_new_jersey_cash_5-95aa3f49143c92e553af5dd740f3fbd9.png";